import { render } from "./highlighted-carousel.vue?vue&type=template&id=55b5c4bb&scoped=true"
import script from "./highlighted-carousel.vue?vue&type=script&lang=js"
export * from "./highlighted-carousel.vue?vue&type=script&lang=js"

import "./highlighted-carousel.vue?vue&type=style&index=0&id=55b5c4bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b5c4bb"]])

export default __exports__